import { useDataProvider } from 'react-admin';
import { useQuery } from '@tanstack/react-query';

const DEFAULT_INVITATION_TTL_DAYS = 30;

export type InvitationSettings = {
    ttlDays: number;
    enforced: boolean;
    autoResendEnabled: boolean;
    autoResendMode: string;
    autoResendSchedule: number[];
};

// Global teacher-invitation settings from admin settings. Cached app-wide so
// per-row usage (e.g. SchoolNameField) triggers only one request.
export const useInvitationSettings = (): InvitationSettings => {
    const dataProvider = useDataProvider();
    const { data } = useQuery({
        queryKey: ['admin', 'settings', 'invitation'],
        queryFn: async () => {
            const res = await (dataProvider as any).getAny(
                'admin/settings',
                ''
            );
            const schedule = res?.data?.invitation_auto_resend_schedule_days;
            return {
                ttlDays:
                    Number(res?.data?.invitation_ttl_days) ||
                    DEFAULT_INVITATION_TTL_DAYS,
                enforced: res?.data?.invitation_ttl_enforced === true,
                autoResendEnabled:
                    res?.data?.invitation_auto_resend_enabled === true,
                autoResendMode:
                    res?.data?.invitation_auto_resend_mode || 'stuck_failed',
                autoResendSchedule: Array.isArray(schedule)
                    ? schedule
                    : [3, 10, 30],
            } as InvitationSettings;
        },
        staleTime: 5 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
    });
    return (
        data ?? {
            ttlDays: DEFAULT_INVITATION_TTL_DAYS,
            enforced: false,
            autoResendEnabled: false,
            autoResendMode: 'stuck_failed',
            autoResendSchedule: [3, 10, 30],
        }
    );
};
